var _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoIconColor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44.790298pt",
    height: "45.010502pt",
    id: "svg267",
    viewBox: "0 0 44.790295 45.010499",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs271"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 447.5741 V 222.6424 H 0 Z",
    style: {
      fill: "none"
    },
    id: "path245"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer1000",
    transform: "translate(-131.0777,-99.794)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 165.2696,120.3288 5.2993,3.0595 5.2991,3.0595 v 6.1189 6.119 l -5.2991,3.0593 -4.1436,2.3922 2.8756,-10.4978 -14.5238,5.1073 -0.1058,-0.061 v -6.119 -6.1189 l 5.2991,-3.0595 z",
    style: {
      fill: "#70138e",
      fillRule: "evenodd"
    },
    id: "path249"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 153.3926,99.794 5.2991,3.0597 5.2994,3.0592 v 6.1191 6.1189 l -5.2994,3.0594 -5.2991,3.0594 -5.2991,-3.0594 -5.2991,-3.0594 v -6.1189 -6.1191 l 5.2991,-3.0592 z",
    style: {
      fill: "#235789",
      fillRule: "evenodd"
    },
    id: "path251"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 141.6759,120.3287 5.2993,3.0597 5.2991,3.0595 v 6.1188 6.1189 l -5.2991,3.0594 -5.2993,3.0595 -5.2991,-3.0595 -5.2991,-3.0594 v -6.1189 -6.1188 l 5.2991,-3.0595 z",
    style: {
      fill: "#76c3cc",
      fillRule: "evenodd"
    },
    id: "path253"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIconColor);
export default __webpack_public_path__ + "static/media/logo_icon_color.4d96ccdb9fac28988d0f3954e19481ef.svg";
export { ForwardRef as ReactComponent };